import positionListStore from '@modules/position/position-list-store';
import positionViewStore from '@modules/position/position-view-store';
import positionImporterStore from '@modules/position/position-importer-store';
import positionFormStore from '@modules/position/position-form-store';
import positionDestroyStore from '@modules/position/position-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: positionDestroyStore,
    form: positionFormStore,
    list: positionListStore,
    view: positionViewStore,
    importer: positionImporterStore,
  },
};
